.tableGrid {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 4px;
  align-items: center;
  flex: 1;
  
  &.hideRoles, &.hideCrmActiveCol {
    grid-template-columns: 2fr 2fr 1fr 1fr 1fr 1fr 1fr;
  }
  
  &.hideRolesAndCrmActiveCol {
    grid-template-columns: 2fr 2fr 1fr 1fr 1fr 1fr;
  }
  
  @include themify($themes) {
    color: themed("main-primary");
  }

  &.tableHeader {
    margin: unset;
    height: 41px;
    font-size: 12px;
    padding: 12px 24px;
    @include themify($themes) {
      border-bottom: solid 1px themed("neutral-secondary");
      color: themed("neutral-primary");
    }
  }
}

.row {
  margin: 0 24px;
  padding: 6px 0;
  opacity: 1;
  height: 55px;
  display: flex;
  text-decoration: none;

  @include themify($themes) {
    border-bottom: solid 1px themed("neutral-secondary");
  }
  
  &:not(.rowHoverDisabled) {
    cursor: pointer;
    
    .tableGrid {
      border-radius: 12px;
      transition: background-color 0.15s ease-out;

      &:hover {
        transition: background-color 0.15s ease-in;
        @include themify($themes) {
          background-color: themed("neutral-tertiary");
        }
      }
    }
  }
}

.usersTable {
  overflow: hidden;
  position: relative;
  margin-top: 24px;
  height: 100%;
  border-radius: 24px 24px 0 0;

  @include themify($themes) {
    background-color: themed("main-secondary");
    border: solid 1px themed("neutral-secondary");
  }
  display: flex;
  flex-direction: column;
}


.switchTextContainer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.defaultChannels {
  margin-top: 20px;
}
